import React from "react";
import "./TermsConditions.css";

const TermsConditions = () => {
  return (
    <div className="tc-wrapper">
      <div className="tc-heading">
        <h2>Terms &amp; Conditions</h2>
      </div>

      <div className="tc-content">
        <p className="tc-lead">
          WireOx LLC reserves the right to modify, suspend, or discontinue any
          feature or section of this website at any time without prior notice.
          Continued use of the platform constitutes acceptance of any revised
          terms.
        </p>

        <section className="tc-section">
          <h3 className="tc-section-title">Account Application:</h3>
          <ol className="tc-list">
            <li>
              It is the customer's sole responsibility to provide accurate,
              complete, and current information on the account application.
              Submission does not guarantee approval of Net terms, credit lines,
              or order approvals.
            </li>
          </ol>
        </section>

        <section className="tc-section">
          <h3 className="tc-section-title">Warranty:</h3>
          <ol className="tc-list">
            <li>
              All products are warranted against defects for thirty (30) days
              from the invoice date, limited to replacement only.
            </li>
            <li>
              Warranty is VOID if:
              <div>(a) Payment not made per agreed terms.</div>
              <div>(b) Item sold AS-IS at time of purchase.</div>
              <div>
                (c) Item subjected to abuse, misuse, alteration, neglect, or
                shipping damage.
              </div>
              <div>(d) Claim submitted after the 30-day period.</div>
            </li>
          </ol>
        </section>

        <section className="tc-section">
          <h3 className="tc-section-title">
            Exchange, Return, Credits and Refund Policies:
          </h3>
          <ol className="tc-list">
            <li>
              All returns require a valid RMA number issued prior to shipment.
              Returns without RMA will be refused.
            </li>
            <li>
              WireOx&apos;s RMA department will evaluate claims within 5-7
              business days.
            </li>
            <li>
              Approved defective items will be replaced with equivalent items
              only.
            </li>
            <li>No cash refunds on non-defective returns.</li>
          </ol>
        </section>

        <section className="tc-section">
          <h3 className="tc-section-title">Limitation of Liability:</h3>
          <p className="tc-paragraph">
            TO THE MAXIMUM EXTENT PERMITTED BY LAW, WIREOX SHALL NOT BE LIABLE
            FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE
            DAMAGES. MAXIMUM LIABILITY SHALL NOT EXCEED THE TOTAL AMOUNT
            INVOICED FOR THE SPECIFIC PRODUCT IN QUESTION.
          </p>
        </section>

        <section className="tc-section">
          <h3 className="tc-section-title">Shipping Policy:</h3>
          <ol className="tc-list">
            <li>
              Shipping, handling, and COD fees are additional unless stated at
              time of sale.
            </li>
            <li>Risk of loss transfers to customer upon handoff to carrier.</li>
            <li>
              Customers must report shipping damage within 48 hours of delivery.
            </li>
            <li>
              Refused or returned shipments are subject to a 20% restocking fee
              plus both-way shipping costs.
            </li>
          </ol>
        </section>

        <section className="tc-section">
          <h3 className="tc-section-title">BAD Checks and Return Checks:</h3>
          <p className="tc-paragraph">
            A $50.00 USD fee will be assessed for any NSF or stop-payment check.
            WireOx may require pre-payment from customers with a history of
            returned checks
          </p>
        </section>

        <section className="tc-section">
          <h3 className="tc-section-title">Collection Chargers:</h3>
          <ol className="tc-list">
            <li>
              WireOx reserves the right to refer any past-due account to a
              collection agency or attorney at any time.
            </li>
            <li>
              The customer agrees to pay all related collection costs, court
              costs, and reasonable attorney's fees.
            </li>
          </ol>
        </section>

        <section className="tc-section">
          <h3 className="tc-section-title">TAX Policy:</h3>
          <p className="tc-paragraph">
            WireOx does not collect sales tax on qualifying wholesale
            transactions. Customers must provide a valid Federal EIN and current
            state-issued resale or tax-exemption certificate prior to ordering.
          </p>
        </section>
      </div>
    </div>
  );
};

export default TermsConditions;
